import { EntityLinks, Goal, ID } from '@griply/types';

import { canGoalHaveChildren } from './can-goal-have-children';
import { getSubGoals } from './get-sub-goals';

export type GetNotAllowedParentGoalIdsOptions = {
  links: EntityLinks;
  goals: Goal[];
};

// The goal's current parent is NOT excluded: it must stay expandable so a deeper target is
// reachable, and re-picking it writes an identical link set, which the builders skip.
// `id` is absent while creating — nothing exists yet to exclude but the projects.
export const getNotAllowedParentGoalIds = (
  id: ID | undefined,
  { goals, links }: GetNotAllowedParentGoalIdsOptions,
): Set<ID> => {
  const subGoals = id ? getSubGoals(id, { goals, recursive: true, links }) : [];
  const projectIds = goals
    .filter((goal) => !canGoalHaveChildren(goal))
    .map((goal) => goal.id);
  return new Set<ID>([
    ...(id ? [id] : []),
    ...subGoals.map((subGoal) => subGoal.id),
    ...projectIds,
  ]);
};
